import { render, staticRenderFns } from "./new_account.vue?vue&type=template&id=4b18ffa6&scoped=true&"
import script from "./new_account.vue?vue&type=script&lang=js&"
export * from "./new_account.vue?vue&type=script&lang=js&"
import style0 from "./new_account.vue?vue&type=style&index=0&id=4b18ffa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18ffa6",
  null
  
)

export default component.exports